/**
 * Fuente única de textos para Información de contacto y Líneas de atención.
 * Usado por: páginas deep-link, modal del footer Home V2 (y cualquier consumidor futuro).
 */
export type ContactoAtencionKind = 'contacto' | 'atencion';

export interface ContactoAtencionItem {
  label: string;
  value: string;
  /** Si existe, el valor se renderiza como enlace (p. ej. mailto:). */
  href?: string;
}

export interface ContactoAtencionContent {
  title: string;
  items: ContactoAtencionItem[];
}

export const CONTACTO_ATENCION_CONTENT: Record<
  ContactoAtencionKind,
  ContactoAtencionContent
> = {
  contacto: {
    title: 'Información de contacto',
    items: [
      {
        label: 'Oficina principal:',
        value: 'Bogotá: Calle 28 No. 13 A 15, piso 39 al 42 C.P.110311',
      },
      {
        label: 'Horario de atención:',
        value: 'Lunes a viernes de 8:00 a.m a 5:00 p.m.',
      },
      {
        label: 'Correo electrónico:',
        value: 'contactenos@bancoldex.com',
        href: 'mailto:contactenos@bancoldex.com',
      },
      {
        label: 'Correo para notificaciones judiciales:',
        value: 'notificacionesjudicialesyadministrativas@bancoldex.com',
      },
    ],
  },
  atencion: {
    title: 'Líneas de atención',
    items: [
      { label: 'Conmutador:', value: '(60-1) 486 3000' },
      { label: 'Fax:', value: '(60-1) 286 2451 / (60-1) 286 0237.' },
      { label: 'Línea gratuita nacional:', value: '01800018 0710.' },
      {
        label: 'Multicontacto Bancóldex Bogotá:',
        value: '(60-1) 7 42 0281.',
      },
    ],
  },
};

export function getContactoAtencionContent(
  kind: ContactoAtencionKind
): ContactoAtencionContent {
  return CONTACTO_ATENCION_CONTENT[kind];
}
